<template>
  <div class="species">
    <div class="display-extinct-info" v-if="displayExtinct">
      <div class="content">
        <div class="warning-icon">
          <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/warning-icon.svg">
        </div>
        <div class="info">
          Has been an extinction event in the last 10 years.
        </div>
        <!-- Required to be removed ME-4087 -->
        <!-- <div class="icon" @click="displayInformationPopup(false)">
          <div class="info-icon">
            <p>i</p>
          </div>
        </div> -->
      </div>
    </div>

    <div class="header">
      <div class="title">
        <h3>{{ speciesData.commonName }}</h3>
      </div>
      <p>{{ speciesData.name }}</p>
    </div>

    <div class="content">


      <div class="top">
        <div class="picture">
          <img :src="speciesData.picture.fields.file.url" alt="species image" />
          <button v-if="getOtherSpeciesCount > 0" @click="displayOtherSpeciesPopup">See all {{ getOtherSpeciesCount }} species</button>
        </div>

        <button class="make-a-difference mobile" @click="makeDifference">
          <span>Make a difference</span>
          <i class="fa fa-angle-down"></i>
        </button>

        <div class="details">
          <div class="section status">
            <div class="heading">
              <h4>Conservation status</h4>
              <!-- Required to be removed ME-4087 -->
              <!--<div class="icon" @click="displayInformationPopup(true)">
                <div class="info-icon">
                  <p>i</p>
                </div>
              </div>-->
            </div>
            <div class="data status">
              <p>{{ speciesData.threatStatus }}</p>
            </div>
          </div>
          <div class="section">
            <div class="heading closable" @click="toggleAbout">
              <h4>About</h4>
              <i class="fa fa-angle-up" v-if="displayAbout"></i>
              <i class="fa fa-angle-down" v-if="!displayAbout"></i>
            </div>
            <div class="data" v-if="displayAbout">
              <p>{{ speciesData.about }}</p>
            </div>
          </div>
          <div class="section">
            <div
              class="heading closable"
              @click="displayFunFact = !displayFunFact"
            >
              <h4>Fun Fact</h4>
              <i class="fa fa-angle-up" v-if="displayFunFact"></i>
              <i class="fa fa-angle-down" v-if="!displayFunFact"></i>
            </div>
            <div class="data" v-if="displayFunFact">
              <p>{{ speciesData.fact }}</p>
            </div>
          </div>
          <div class="section" v-if="hasFirstNationsInfo">
            <div
              class="heading closable"
              @click="displayFirstNationsInfo = !displayFirstNationsInfo"
            >
              <h4>Further first nations information</h4>
              <i class="fa fa-angle-up" v-if="displayFirstNationsInfo"></i>
              <i class="fa fa-angle-down" v-if="!displayFirstNationsInfo"></i>
            </div>
            <div class="data" v-if="displayFirstNationsInfo">
              <p>{{ speciesData.languageExtraInfo }}</p>
            </div>
          </div>
          <div class="section">
            <div class="heading closable">
              <h4>Key threats</h4>
            </div>
            <div class="threats">
              <div
                class="threat"
                v-for="threat of speciesData.threats"
                :key="threat.fields.name"
              >
                <div class="threat-icon">
                  <img
                    :src="threat.fields.icon.fields.file.url"
                    :alt="threat.name"
                  />
                </div>
                <div class="threat-name">
                  <p>{{ threat.fields.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="make-a-difference desktop" @click="makeDifference">
        <span>Add your voice</span>
        <i class="fa fa-angle-down"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroSpecies",
  data() {
    return {
      // Species details toggles
      displayAbout: false,
      displayFunFact: false,
      displayFirstNationsInfo: false,
      hasFirstNationsInfo: false,
    };
  },
  computed: {
    speciesData() {
      return this.$store.getters.speciesData;
    },
    displayExtinct() {
      return this.$store.getters.numExtinct > 0;
    },
    getOtherSpeciesCount() {
      return this.$store.getters.otherSpecies.length || 0;
    },
  },

  watch: {
    speciesData(newValue) {
      if (newValue.languageTerm) {
        newValue.commonName = `${newValue.commonName} - ${newValue.languageTerm} / ${newValue.languageGroup}`;

        if (newValue.languageExtraInfo) this.hasFirstNationsInfo = true;
        else this.hasFirstNationsInfo = false;
      } else this.hasFirstNationsInfo = false;

      this.displayAbout = false;
      this.displayFunFact = false;
      this.displayFirstNationsInfo = false;
    },
  },

  mounted() {
    if (this.speciesData.name !== "") {
      if (this.speciesData.languageTerm) {
        this.speciesData.commonName = `${this.speciesData.commonName} - ${this.speciesData.languageTerm} / ${this.speciesData.languageGroup}`;

        if (this.speciesData.languageExtraInfo) this.hasFirstNationsInfo = true;
        else this.hasFirstNationsInfo = false;
      } else this.hasFirstNationsInfo = false;
    }
  },

  methods: {
    toggleAbout() {
      this.displayAbout = !this.displayAbout;
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Species Detail Concertina",
        eventProperties: { Click: true },
      });
    },

    displayInformationPopup(conservationStatus) {
      if (conservationStatus) {
        this.$store.commit("updatePopupTitle", "What is conservation status?");
        this.$store.commit(
          "updatePopupDescription",
          "Many factors are used to assess the conservation status of an animal or plant. Under the EPBC Act, the status indicates its risk of extinction via one of the following categories: ‘Conservation Dependent’,  ‘Vulnerable’, ‘Endangered’, ‘Critically Endangered’, ‘Extinct in Wild’ and ‘Extinct’."
        );
      } else {
        this.$store.commit("updatePopupTitle", "Extinction Event");
        this.$store.commit(
          "updatePopupDescription",
          "In the past 10 years, an animal or plant has become extinct and no longer exists in the area. This may be a complete extinction, where the species no longer exists anywhere in the world, or it could be extinction in the wild, where they no longer exist in their natural habitat."
        );
      }

      this.$store.commit("updateOpenInformationPopup", true);
      document.getElementById("mby-top").scrollIntoView({
        behavior: "smooth",
        block: "end",
      });

      // Log info popup
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Info Pop Up",
        eventProperties: {
          "Related Content Text": conservationStatus
            ? "Conservation Status"
            : "Extinction Event",
        },
      });
    },

    displayOtherSpeciesPopup() {
      this.$store.commit("updateOpenOtherSpeciesPopup", true);

      // Log close popup
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Other species",
        eventProperties: { "Open": 'Other species' },
      });
    },

    makeDifference() {
      document.getElementById("form-top").scrollIntoView({
        behavior: "smooth",
      });

      // Log make diff btn press
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Make a Difference Button",
        eventProperties: {
          Click: true,
          "Map State": this.electorateName,
        },
      });
    },
  },
};
</script>

<style scoped>
h3 {
  padding: 0;
  margin: 0;
}

h3:before {
  background-color: transparent;
}

.info-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px solid #323232;
  border-radius: 100%;
  padding: 4px;
  width: 24px;
  height: 24px;
}

.info-icon.light {
  border-color: var(--white);
}

.species {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
  width: 100%;
  padding: 0 64px;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.header .title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.header .title h3 {
  font-family: "WWF",sans-serif;
  text-transform: uppercase;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.top {
  display: flex;
  gap: 24px;
  width: 100%;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  border-top: 1px solid #dadada;
  padding-top: 12px;
}

.section .heading {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}

.section .heading.closable {
  justify-content: space-between;
  cursor: pointer;
}

.icon {
  cursor: pointer;
}

.section h4 {
  font-family: "WWF",sans-serif;
  font-size: 32px;
  margin: 0px;
  text-transform: uppercase;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}

.picture {
  position: relative;
  width: 700px;
  height: 700px;
}

.picture img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.picture button {
  position: absolute;
  bottom: 26px;
  right: 18px;
  cursor: pointer;
  padding: 10px 20px;
  color: #FFF;
  font-family: "WWF",sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  border: 1px solid #ffffff;
  border-radius: 8px;
}

.section .data {
  display: flex;
  align-items: center;
}

.section.status {
  flex-direction: row;
  justify-content: space-between;
  border-top: none;
}

.section.status .heading {
  display: flex;
  gap: 8px;
}

.details .data.status {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: -0.023em;
  color: #1e1e1e;
}

.threats {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.threat {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 150px;
}

.threat .threat-icon {
  width: 64px;
  height: 64px;
}

.threat .threat-name {
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.2px;
  text-transform: capitalize;
  text-align: center;
  color: #212121;
}

.threat .threat-name p {
  font-family: "WWF",sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}

.display-extinct-info {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
  gap: 24px;
  height: 100px;
  padding: 12px;
  background-color: var(--orange);
}

.display-extinct-info .content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  height: 100px;
  background-color: var(--orange);
}

.display-extinct-info p {
  font-weight: 400;
  font-size: 18px;
  color: var(--black);
}

.display-extinct-info .info {
  color: var(--black);
  font-family: "WWF",sans-serif;
  font-size: 32px;
  text-transform: uppercase;
  margin-top: -4px;
}

.display-extinct-info .warning-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
}

.make-a-difference {
  background-color: #007932;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  cursor: pointer;
}

.make-a-difference span {
  font-family: "WWF",sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  color: var(--white);
}

.make-a-difference i {
  font-size: 15px;
  color: var(--white);
}

.make-a-difference.mobile {
  display: none;
}

@media only screen and (max-width: 1000px) {
  .top {
    flex-direction: column;
  }

  .top .picture {
    width: 100%;
  }
}

@media only screen and (max-width: 700px) {
  .top .picture {
    height: 600px;
  }
}

@media only screen and (max-width: 650px) {
  .display-extinct-info .warning-icon {
    width: 74px;
  }

  .display-extinct-info .info {
    font-size: 18px;
  }

  .display-extinct-info .icon {
    display: none;
  }

  .header .title h3 {
    font-size: 40px;
    line-height: 45px;
  }

  .section h4 {
    font-size: 24px;
  }

  .make-a-difference.desktop {
    display: none;
  }

  .make-a-difference.mobile {
    display: flex;
  }
}

@media only screen and (max-width: 600px) {
  .top .picture {
    height: 500px;
  }

  .section.status {
    flex-direction: column;
    justify-content: center;
    gap: 0px;
  }

  .section.status .heading {
    justify-content: space-between;
    gap: 0;
  }

  .display-extinct-info {
    padding: 0 12px;
  }
}

@media only screen and (max-width: 560px) {
  .species {
    padding: 0 16px;
  }

  .display-extinct-info {
    gap: 8px;
  }

  .display-extinct-info .icon {
    display: flex;
    align-items: flex-start;
    height: 100%;
    padding-top: 10px;
    display: none;
  }

  .display-extinct-info .content {
    gap: 8px;
  }

  .display-extinct-info .warning-icon {
    width: 70px;
  }
}

@media only screen and (max-width: 480px) {
  .display-extinct-info .warning-icon {
    width: 100px;
  }
}

/* Elcom Style */
h1, h2, h3 {
  font-family: "WWF",sans-serif;
  position: relative;
  z-index: 1;
}

h3 {
  font-size: 42px;
}

p {
  font-family: 'Lato',sans-serif;
  position: relative;
  margin: 0;
  font-size: 16px;
}

h4 {
  font-family: 'Lato',sans-serif;
  font-weight: 600;
  font-size: 26;
}
/* END */
</style>



// WEBPACK FOOTER //
// HeroSpecies.vue?06eb2022